import styled from 'styled-components';
import { spacer20, screenSmMin } from '@spotify-internal/encore-foundation';
import Type from "../Type";
export default styled(Type.h1).attrs({
  variant: Type.heading3
}).withConfig({
  displayName: "BodyTitle",
  componentId: "x472m4-0"
})(["padding-bottom:", ";@media (min-width:", "){text-align:center;}"], spacer20, screenSmMin);